/**
 * @description [機車險] 立方公分/馬力 條件表達符
*/
export enum VehiclePowerValidationExpressionSymbols {
  /** 大於 */
  GT = 'GT',
  /** 大於等於 */
  GE = 'GE',
  /** 小於 */
  LT = 'LT',
  /** 小於等於 */
  LE = 'LE'
}

export enum VehiclePowerValidationExpressionSymbolsString {
  /** 大於 */
  GT = '大於',
  /** 大於等於 */
  GE = '大於等於',
  /** 小於 */
  LT = '小於',
  /** 小於等於 */
  LE = '小於等於'
}
